import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AutoScroll(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    document?.querySelector("main > section")?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
